import styles from './disinfect.module.css';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/src/ScrollTrigger';
import { useEffect } from 'react';
import { useRef } from 'react';
import DOMPurify from 'dompurify';
gsap.registerPlugin(ScrollTrigger);
const Disinfect = ({ textData }) => {
  const ctnRef = useRef(null);
  const text1Ref = useRef(null);
  const text2HRef = useRef(null);
  const text2PRef = useRef(null);
  const text3HRef = useRef(null);
  const text3PRef = useRef(null);
  const text6Ref = useRef(null);
  const text7Ref = useRef(null);
  const text8Ref = useRef(null);
  // const productImgRef = useRef(null);
  // const phoneImgRef = useRef(null);
  // const phoneBoxRef = useRef(null);
  const sceneRef = useRef(null);
  const scene0Ref = useRef(null);
  const scene1Ref = useRef(null);
  const scene2Ref = useRef(null);
  const scene3Ref = useRef(null);
  // const disinfectStateRef = useRef(null);
  // const disinfectCompleteStateRef = useRef(null);
  const canvasRef = useRef(null);
  const disinfectAnimation = () => {
    const currentFrame = (index) =>
      `https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/ozone-speaker/zhiyunlife-ozonespeaker-animation-2/zhiyunlife-ozonespeaker-animation-${(
        index + 1
      )
        .toString()
        .padStart(5, '0')}.jpg`;

    const canvas = canvasRef.current;
    // console.log(canvas);
    const context = canvas.getContext('2d');
    canvas.width = 2560;
    canvas.height = 1440;
    const frameCount = 207;
    const images = [];
    const xdbFrames = {
      frame: 0,
    };

    for (let i = 0; i < frameCount; i++) {
      const img = new Image();
      img.src = currentFrame(i);
      // console.log(img.src);
      images.push(img);
    }

    images[xdbFrames.frame].onload = render;

    function render() {
      // console.log(xdbFrames.frame);
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.drawImage(images[xdbFrames.frame], 0, 0);
    }

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: ctnRef.current,
        start: 'top top',
        pin: true,
        end: '600%',
        pinSpacing: true,
        scrub: 1,
      },
    });

    tl.to(xdbFrames, {
      frame: 167,
      snap: 'frame',
      onUpdate: render,
      duration: 40,
    });

    tl.to(
      text1Ref.current,
      {
        y: 'var(--effect-offset-y)',
        duration: 4,
      },
      0,
    );

    tl.to(
      text1Ref.current,
      {
        opacity: 1,
        duration: 0.5,
      },
      0,
    );

    tl.to(
      text1Ref.current,
      {
        opacity: 0,
        duration: 1,
      },
      3,
    );

    tl.to(
      text2HRef.current,
      {
        y: 'var(--effect-offset-y)',
        duration: 6,
      },
      12,
    );

    tl.to(
      text2HRef.current,
      {
        opacity: 1,
        duration: 0.5,
      },
      12,
    );

    tl.to(
      text2PRef.current,
      {
        y: 'var(--effect-offset-y)',
        duration: 6,
      },
      13,
    );

    tl.to(
      text2PRef.current,
      {
        opacity: 1,
        duration: 0.5,
      },
      13,
    );

    tl.to(
      text2HRef.current,
      {
        opacity: 0,
        duration: 1,
      },
      17,
    );

    tl.to(
      text2PRef.current,
      {
        opacity: 0,
        duration: 1,
      },
      17,
    );

    //

    tl.to(
      text3HRef.current,
      {
        y: 'var(--effect-offset-y)',
        duration: 10,
      },
      18,
    );

    tl.to(
      text3HRef.current,
      {
        opacity: 1,
        duration: 0.5,
      },
      18,
    );

    tl.to(
      text3PRef.current,
      {
        y: 'var(--effect-offset-y)',
        duration: 10,
      },
      19,
    );

    tl.to(
      text3PRef.current,
      {
        opacity: 1,
        duration: 0.5,
      },
      19,
    );

    tl.to(
      text3HRef.current,
      {
        opacity: 0,
        duration: 1,
      },
      29,
    );

    tl.to(
      text3PRef.current,
      {
        opacity: 0,
        duration: 1,
      },
      29,
    );

    tl.to(
      sceneRef.current,
      {
        opacity: 1,
        visibility: 'visible',
        duration: 0.5,
      },
      27.5,
    );

    tl.to(
      text6Ref.current,
      {
        y: 'var(--effect-offset-y)',
        duration: 4,
      },
      30,
    );

    tl.to(
      text6Ref.current,
      {
        opacity: 1,
        duration: 0.5,
      },
      30,
    );

    tl.to(
      text6Ref.current,
      {
        opacity: 0,
        duration: 1,
      },
      33,
    );

    tl.to(
      text7Ref.current,
      {
        y: 'var(--effect-offset-y)',
        duration: 4,
      },
      34,
    );

    tl.to(
      text7Ref.current,
      {
        opacity: 1,
        duration: 0.5,
      },
      34,
    );

    tl.to(
      text7Ref.current,
      {
        opacity: 0,
        duration: 1,
      },
      37,
    );

    tl.to(
      text8Ref.current,
      {
        y: 'var(--effect-offset-y)',
        duration: 4,
      },
      38,
    );

    tl.to(
      text8Ref.current,
      {
        opacity: 1,
        duration: 0.5,
      },
      38,
    );

    // tl.to(
    //   text8Ref.current,
    //   {
    //     opacity: 0,
    //     duration: 1,
    //   },
    //   41,
    // );

    tl.to(
      scene0Ref.current,
      {
        '--effect-clip-path-bottom': '100%',
        duration: 4,
      },
      28,
    );

    tl.to(
      scene1Ref.current,
      {
        '--effect-clip-path-bottom': '100%',
        duration: 4,
      },
      32,
    );

    tl.to(
      scene2Ref.current,
      {
        '--effect-clip-path-bottom': '100%',
        duration: 4,
      },
      36,
    );

    // tl.to(
    //   scene3Ref.current,
    //   {
    //     '--effect-clip-path-bottom': '100%',
    //     duration: 4,
    //   },
    //   40,
    // );

    //
  };
  useEffect(() => {
    disinfectAnimation();
  }, []);

  return (
    <div className={styles.ctn} ref={ctnRef}>
      <canvas ref={canvasRef}></canvas>
      <h3
        ref={text1Ref}
        className={`${styles.text1} ${styles.effectText}`}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text6']),
        }}
      ></h3>

      <div className={styles.text2Box}>
        <div className={styles.text2HeaderBox}>
          <h1
            className={`${styles.text2H} ${styles.effectText}`}
            ref={text2HRef}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text7']),
            }}
          ></h1>
        </div>

        <h5
          ref={text2PRef}
          className={styles.effectText}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text8']),
          }}
        ></h5>
      </div>

      <div className={styles.text3Box}>
        <div className={styles.text3HeaderBox}>
          <h1
            className={`${styles.text2H} ${styles.effectText}`}
            ref={text3HRef}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData['text9']),
            }}
          ></h1>
        </div>

        <h5
          ref={text3PRef}
          className={styles.effectText}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text10']),
          }}
        ></h5>
      </div>

      <h1
        className={`${styles.text6} ${styles.effectText}`}
        ref={text6Ref}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text11']),
        }}
      ></h1>
      <h1
        className={`${styles.text7} ${styles.effectText}`}
        ref={text7Ref}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text12']),
        }}
      ></h1>

      <h1
        className={`${styles.text8} ${styles.effectText}`}
        ref={text8Ref}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text13']),
        }}
      ></h1>

      <div className={styles.scene} ref={sceneRef}>
        <img
          className={styles.scene3}
          ref={scene3Ref}
          src="https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/ozone-speaker/zhiyunlife-ozonespeaker-scene3.jpg"
          alt=""
        />

        <img
          className={styles.scene2}
          ref={scene2Ref}
          src="https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/ozone-speaker/zhiyunlife-ozonespeaker-scene2.jpg"
          alt=""
        />

        <img
          className={styles.scene1}
          ref={scene1Ref}
          src="https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/ozone-speaker/zhiyunlife-ozonespeaker-scene1.jpg"
          alt=""
        />

        <img
          className={styles.scene0}
          ref={scene0Ref}
          src="https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/ozone-speaker/zhiyunlife-ozonespeaker-scene0.jpg"
          alt=""
        />
      </div>
    </div>
  );
};

export default Disinfect;
